import { render } from "./PregnancySettingsModal.vue?vue&type=template&id=892f4c62&scoped=true"
import script from "./PregnancySettingsModal.vue?vue&type=script&lang=js"
export * from "./PregnancySettingsModal.vue?vue&type=script&lang=js"

import "./PregnancySettingsModal.vue?vue&type=style&index=0&id=892f4c62&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892f4c62"]])

export default __exports__